import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { RootState } from '../store'
import { logOut, logOutGuest, setCredentials } from '../../features/auth/authSlice'
import { RefreshTokenResponse, UserCredential } from '../../types/response'
import { API_BASE_URL } from '../../utils/env'

const baseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
        const accessToken  = (getState() as RootState).auth.userCredentials?.accessToken
        if (accessToken ) {
            headers.set("authorization", `Bearer ${accessToken }`)
        }
        return headers
    }
})

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
    
    const state = api.getState() as RootState;
    const refreshTokenValue = state.auth.userCredentials?.refreshToken
    let result = await baseQuery(args, api, extraOptions);

    if (result?.error?.status === 401 || result?.error?.status === "PARSING_ERROR") {
        if(refreshTokenValue){
            const refreshResult = await baseQuery(
                {
                    url: '/api/staff/refresh-token',
                    method: 'POST',
                },
                api,
                extraOptions
            );
            if (refreshResult?.data) {
                const response = refreshResult.data as RefreshTokenResponse;
                const finalResponse = response.data
                const credential: UserCredential = {
                    isNewUsername: false,
                    accessToken: finalResponse?.accessToken,
                    refreshToken: finalResponse?.refreshToken,
                    staff: {
                        staffID: finalResponse?.staffID ?? null,
                        firstName: finalResponse?.firstName ?? '',
                        middleInitial: finalResponse?.middleInitial ?? '',
                        lastName: finalResponse?.lastName ?? '',
                        email: finalResponse?.email ?? '',
                        phone: null,
                        role: finalResponse?.role,
                        status: finalResponse?.status ?? '',
                        roleId: null,
                        statusId: null,

                        sessionId: finalResponse?.sessionID ?? null,
                        clientID: finalResponse?.clientID ?? null,
                        token: finalResponse?.token ?? '',
                        userName: finalResponse?.userName ?? '',
                        generatedUsername: finalResponse.generatedUserName ?? '',
                        deceasedName: ''
                    }
                };

                api.dispatch(setCredentials(credential));
                result = await baseQuery(args, api, extraOptions);
            } else {
                api.dispatch(logOut());
            }
        } else {
            api.dispatch(logOutGuest());
        }
    }
    return result;
};

export const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    endpoints: builder => ({}),
    tagTypes: [
        'Chapel', 'SpecialPack', 'Staff', 'Order', 'Product', 
        'Category', 'Package', 'Client', 'Cart', 'Orders', 'AddOns',
        'Temperature', 'Size', 'ClientProduct'
    ],
})